import { useZocksQuota } from '../../components/ScopedBlock/hooks'

export const INVITE_REQUEST_QUOTA = 'auth.inviteRequestEnabled.value'

export const useInviteFlowRevampEnabled = () => {
  const { hasQuota, quotaSuccess, isFetching } = useZocksQuota()

  return {
    isEnabled: hasQuota(INVITE_REQUEST_QUOTA),
    isLoading: !quotaSuccess && isFetching,
  }
}
